<template>
  <div class="schoolCardList-container div-layout">
    <module-title title="异常监控管理员列表">
      <div class="right">
        <el-button
          type="primary"
          size="medium"
          @click="opAddOrView('set')"
        >
          设置监控规则
        </el-button>
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-plus"
          @click="opAddOrView('add')"
        >
          添加管理员
        </el-button>
      </div>
    </module-title>
    <div class="schoolCardList-right-contain">
      <el-table
        v-loading="listLoading"
        :data="dataList"
        fit
        element-loading-text="Loading"
        class="list-table"
        highlight-current-row
      >
        <el-table-column label="序号" type="index" align="center" width="55" />
        <el-table-column label="姓名" prop="name" align="center" />
        <el-table-column label="邮箱" prop="email" align="center" />
        <el-table-column label="手机号" prop="phone" align="center" />
        <el-table-column label="操作账号" prop="createUserCode" align="center" />
        <el-table-column label="操作时间" prop="updateDate" align="center" />
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="small"
              icon="el-icon-delete"
              @click="remove(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        :total="searchForm.total"
        :page.sync="searchForm.pageNum"
        :limit.sync="searchForm.pageSize"
        @pagination="pagedisableSettings"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <!-- 设置监控规则 -->
    <el-dialog
      destroy-on-close
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="540px"
      title="设置监控规则"
    >
      <el-form
        ref="handleForm"
        v-loading="monitorLoading"
        :rules="handleRules"
        :model="handleForm"
        label-position="right"
        label-width="120px"
      >
        <el-form-item
          label="监控数据天数："
          prop="monitorDay"
        >
          <el-select
            v-model="handleForm.monitorDay"
            name="monitorDay"
            size="medium"
            class="handle-form-input"
          >
            <el-option label="7天" :value="7" />
            <el-option label="3天" :value="3" />
            <el-option label="自定义" value="" />
          </el-select>
          <el-input
            v-if="handleForm.monitorDay===''"
            v-model="handleForm.monitorDayC"
            name="range"
            auto-complete="off"
            size="medium"
            placeholder="请输入自定义"
            class="inlineblock"
            oninput="value=value.replace(/[^\d]/g,'')"
            clearable
          />
        </el-form-item>
        <div v-for="(item,index) in monitorrulesList" :key="item.id" class="addRules">
          <el-input
            v-model="item.monitorName"
            name="studentName"
            auto-complete="off"
            maxlength="11"
            class="handle-form-input"
            size="medium"
            placeholder="请输入规则名称"
            clearable
          />
          <el-date-picker
            v-model="item.dateTime"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="起始日期"
            end-placeholder="截至日期"
            class="handle-form-date"
            @change="handelChangeDateTime($event,item.dateTime)"
          />
          <span style="width:50px" @click="mointorRuleDel(index)">删除</span>
        </div>
        <div class="addRulesBnt" @click="mointorRuleAdd()">
          添加规则
        </div>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          @click="dialogVisible = false"
        >
          取消
        </el-button>
        <el-button
          :loading="ajaxLoading"
          type="primary"
          size="medium"
          @click="handleAddUpgrade"
        >
          {{ ajaxLoading?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
    <!-- 添加 -->
    <el-dialog
      v-if="dialogVisibleAddManage"
      destroy-on-close
      :close-on-click-modal="false"
      :visible.sync="dialogVisibleAddManage"
      width="540px"
      title="添加管理员"
    >
      <el-form
        ref="handleFormManage"
        :rules="handleManageRules"
        :model="handleFormManage"
        label-position="right"
        label-width="120px"
      >
        <el-form-item label="姓名：" prop="name">
          <el-input
            v-model="handleFormManage.name"
            name="name"
            auto-complete="off"
            maxlength="4"
            class="handle-form-input"
            size="medium"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label="邮箱：" prop="email">
          <el-input
            v-model="handleFormManage.email"
            name="email"
            auto-complete="off"
            class="handle-form-input"
            size="medium"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
        <el-form-item label="手机号：" prop="phone">
          <el-input
            v-model="handleFormManage.phone"
            name="phone"
            auto-complete="off"
            maxlength="11"
            class="handle-form-input"
            size="medium"
            placeholder="请输入"
            clearable
          />
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          size="medium"
          @click="dialogVisibleAddManage = false"
        >
          取消
        </el-button>
        <el-button
          :loading="ajaxLoadingManage"
          type="primary"
          size="medium"
          @click="handleAddManage"
        >
          {{ ajaxLoadingManage?'Loading':'确定' }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMonitoradminsList,
  getMonitorrulesAdd,
  getMonitorrulesDel,
  getMonitorrulesSet,
  getMonitorrules
} from '@/api/systemMaintenance/devicManage/abnormalMonitoringManage';
import { mapGetters } from 'vuex';
import { validatePhoneM, validateUserName, validateEmail } from '@/utils/validate';
import { deepCopy } from '@/utils/index';

export default {
  name: 'AbnormalMonitoringManage',

  data() {
    var validateTimeLimit = (rule, value, callback) => {
      const handleForm = this.handleForm;
      if (handleForm.monitorDay === '' && handleForm.monitorDayC === '') {
        callback(new Error('监控数据天数不能为空'));
      } else {
        callback();
      }
    };
    return {
      monitorrulesList: null,
      searchForm: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      handleForm: {
        monitorDay: '',
        monitorDayC: ''
      },
      handleFormManage: {
        name: '',
        email: '',
        phone: '',
        createUserCode: '',
        status: ''
      },
      handleRules: {
        monitorDay: [
          { trigger: 'change', validator: validateTimeLimit }
        ]
      },
      handleManageRules: {
        name: [
          { required: true, trigger: 'blur', validator: validateUserName }
        ],
        email: [
          { trigger: 'blur', validator: validateEmail }
        ],
        phone: [
          { trigger: 'blur', validator: validatePhoneM }
        ]
      },
      listLoading: false,
      monitorLoading: false,
      ajaxLoading: false,
      dialogVisible: false,
      ajaxLoadingManage: false,
      dialogVisibleAddManage: false,
      dataList: []
    };
  },
  mounted() {
    this.fetchCunwAppList();
    // this.fetchManageConfigList();
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    // 获取列表名单
    fetchMonitorrules() {
      this.monitorLoading = true;
      getMonitorrules().then(res => {
        if (res.data && res.data.length > 0) {
          this.monitorrulesList = res.data;
          this.monitorrulesList.map(item => {
            this.$set(item, 'dateTime', [item.startDate, item.endDate]);
            return item;
          });

          if (res.data[0].monitorDay === 3 || res.data[0].monitorDay === 7) {
            this.handleForm.monitorDay = res.data[0].monitorDay;
          } else {
            this.handleForm.monitorDay = '';
            this.handleForm.monitorDayC = res.data[0].monitorDay;
          }
        } else {
          this.monitorrulesList = [];
        }
        this.monitorLoading = false;
      });
    },
    // 分页
    pagedisableSettings(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchCunwAppList();
    },

    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchCunwAppList();
    },
    // 弹框
    opAddOrView(type, row) {
      if (type === 'add') {
        this.dialogVisibleAddManage = true;
        this.handleFormManage = {
          name: '',
          email: '',
          phone: '',
          createUserCode: '',
          status: ''
        };
      } else {
        this.dialogVisible = true;
        this.fetchMonitorrules();
      }
    },
    // 异常监控管理员列表
    fetchCunwAppList() {
      this.listLoading = true;
      this.dataList = [];
      const option = {
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      getMonitoradminsList(option).then(res => {
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.dataList = res.data.list;
          this.searchForm.total = res.data.total;
        }
        this.listLoading = false;
      }).catch((error) => {
        this.listLoading = false;
        this.searchForm.total = 0;
        this.$message({
          message: error.data.message,
          type: 'error',
          duration: 3 * 1000
        });
      });
    },
    // 删除
    remove(row) {
      var whileListId = row.id;
      this.$confirm(`确定是否删除？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => getMonitorrulesDel(whileListId))
        .then(res => {
          this.$notify.success({
            title: 'Success',
            message: '删除成功',
            showClose: false,
            duration: 2000
          });
          this.fetchCunwAppList();
        })
        .catch(err => {
          console.log(err);
        });
    },
    handelChangeDateTime(val, item) {
      console.log(val, item);
    },
    // 添加管理员
    handleAddManage() {
      this.$refs['handleFormManage'].validate(valid => {
        if (valid) {
          this.ajaxLoadingManage = true;
          var options = {
            name: this.handleFormManage.name,
            email: this.handleFormManage.email,
            phone: this.handleFormManage.phone,
            status: this.handleFormManage.status,
            createUserCode: this.userInfo.code ? this.userInfo.code : ''
          };
          if (!options.phone && !options.email) {
            this.$message.error('邮箱与手机号不能同时为空');
            this.ajaxLoadingManage = false;
            return;
          }
          getMonitorrulesAdd(options)
            .then(res => {
              this.$notify.success({
                title: 'Success',
                message: '操作成功',
                showClose: false,
                duration: 2000
              });
              this.ajaxLoadingManage = false;
              this.dialogVisibleAddManage = false;
              this.fetchCunwAppList();
            })
            .catch(err => {
              this.ajaxLoadingManage = false;
              console.log(err);
            });
        }
      });
    },
    // 设置监控规则删除
    mointorRuleDel(index) {
      this.monitorrulesList.splice(index, 1);
    },
    // 设置监控规则添加
    mointorRuleAdd() {
      this.monitorrulesList.push({
        monitorName: '',
        dateTime: ''
      });
    },
    // 设置监控规则
    handleAddUpgrade() {
      this.$refs['handleForm'].validate(valid => {
        if (valid) {
          var options = [];
          this.ajaxLoading = true;
          options = deepCopy(this.monitorrulesList);
          options = options.map(v => {
            if (v.dateTime.length > 0 || v.monitorName) {
              v.monitorDay = this.handleForm.monitorDay ? this.handleForm.monitorDay : this.handleForm.monitorDayC;
              v.startDate = v.dateTime[0];
              v.endDate = v.dateTime[1];
              delete v.dateTime;
            }
            return v;
          }).filter(v => v.monitorDay && v.startDate && v.endDate);
          getMonitorrulesSet(options)
            .then(res => {
              this.$notify.success({
                title: 'Success',
                message: '操作成功',
                showClose: false,
                duration: 2000
              });
              this.ajaxLoading = false;
              this.dialogVisible = false;
              this.fetchCunwAppList();
            })
            .catch(err => {
              this.ajaxLoading = false;
              console.log(err);
              console.log(this.monitorrulesList);
            });
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.schoolCardList-container {
  .addRules{
    margin-top: 10px;
    display: flex;
    align-items: center;
    .handle-form-input{
      width: 45%;
      margin-right: 10px;
    }
      .handle-form-date{
      width: 65%;
      margin-right: 10px;
    }
    span{
      color: red;
    }
  }
  .addRulesBnt{
    text-align: center;
    padding-top: 8px;
    color: #1890ff;
  }
  .edit-form-input {
    width: 6.8vw;
  }
  .textCenter {
    text-align: center;
    padding: 20px;
    .el-button {
      width: 160px;
    }
  }
  // .handle-form-input{ width: 160px;}
  // 查看详情
  .archivesTitle {
    color: #1890ff;
    font-size: 14px;
    font-weight: bold;
    padding-left: 30px;
    padding-bottom: 20px;
  }
  .red {
    color: red;
  }
  .manager-info {
    ul {
      margin-left: 60px;
      width: 50%;
      min-width: 220px;
      li {
        margin-bottom: 20px;
      }
    }
  }
  .inlineblock{
    width: 130px;
    margin-left: 5px;
  }
}
</style>
